import { render } from "./B2bTableMenuIssues.vue?vue&type=template&id=7c951677&scoped=true&lang=pug"
import script from "./B2bTableMenuIssues.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuIssues.vue?vue&type=script&lang=js"

import "./B2bTableMenuIssues.vue?vue&type=style&index=0&id=7c951677&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c951677"]])

export default __exports__